import { Cliente } from '../cliente';

export class ClienteDireccion {
    n?:string;
    id?:string;
    direccion?:string;
    cliente?:Cliente;
    
    constructor(){
        this.cliente = new Cliente();
    }

}
